import React from 'react';

const ArticlesIntro = () => {
  return (
    <div className='articles_intro'>
      <p className='articles_intro_card'>
        Discover 1,000+ free, up-to-the-minute <span>tech articles</span>, keeping you in the loop with the fast-paced world of technology
      </p>
    </div>
  )
}

export default ArticlesIntro
